export default {
  // TODO: remove legacy trads once old hero is killed
  bestSale: {
    id: 'landing_hero_best_sale',
    defaultMessage: 'Best sale',
  },
  landingHeroDiscount: {
    id: 'landing_hero_discount_variable',
    defaultMessage: '{discount} discount',
  },
  landingHeroWarranty: {
    id: 'landing_hero_warranty',
    defaultMessage: 'Warranty:',
  },
  condition: {
    id: 'landing_hero_condition',
    defaultMessage: 'Condition:',
  },
  landingHeroElectronicWasteSavedNew: {
    id: 'landing_hero_electronic_waste_saved_new',
    defaultMessage: '{weight} oz of e-waste saved',
  },
  landingHeroLinkLabel: {
    id: 'landing_hero_link_label',
    defaultMessage: 'See more',
  },
  landingHeroButtonLabel: {
    id: 'landing_hero_button_label',
    defaultMessage: 'See more products',
  },
  serviceWarranty: {
    id: 'landing_service_warranty',
    defaultMessage: '{warrantyDuration}-year minimum warranty',
  },
  originalPriceDisplay: {
    id: 'landing_hero_original_price_display',
    defaultMessage: '{price} new',
  },
}
